import { SalesOrderDemandShipment } from '../../redux/types';

export const getVisibleShipmentColumns = (shipments: SalesOrderDemandShipment[]) => ({
    hasStatus: shipments.some((s) => s.status),
    hasTrackingNumber: shipments.some((s) => s.trackingNumber),
    hasDeliveryDate: shipments.some((s) => s.deliveryDate),
});
